import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateFilPH: NDateLocale = {
  name: 'fil-PH',
  locale: enUS
}

export default dateFilPH
